// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { ArrowLeft as RawArrowLeft } from "lucide-react";
export const ArrowLeft = /* @__PURE__ */ createIcon(RawArrowLeft, "ArrowLeft", 2);
